import React from 'react';
import { Menu, LogOut } from 'lucide-react';
import { useAdminAuth } from '../context/AdminAuthContext';
import { isSupabaseConfigured } from '../../lib/supabaseClient';

export default function AdminHeader({ onMenuClick, title }) {
  const { user, logout } = useAdminAuth();

  return (
    <header className="h-20 bg-slate-950/80 backdrop-blur-md border-b border-slate-800/80 sticky top-0 z-30 px-4 sm:px-8 flex items-center justify-between">
      {/* Left: Mobile Toggle & Page Title */}
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="p-2 rounded-xl text-slate-400 hover:text-white hover:bg-slate-900 lg:hidden border border-slate-800"
        >
          <Menu size={20} />
        </button>
        <div>
          <h1 className="text-base sm:text-xl font-bold text-white tracking-tight">
            {title || 'Dashboard'}
          </h1>
          <p className="text-[11px] text-slate-400 hidden sm:block">
            VJ Dsign Studio CMS & Management Console
          </p>
        </div>
      </div>

      {/* Right: Connection Badge, Admin Info, Logout */}
      <div className="flex items-center gap-3 sm:gap-4">
        {/* Backend Status Indicator */}
        <div
          className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-semibold border ${
            isSupabaseConfigured
              ? 'bg-emerald-950/40 text-emerald-400 border-emerald-800/50'
              : 'bg-amber-950/40 text-amber-400 border-amber-800/50'
          }`}
          title={
            isSupabaseConfigured
              ? 'Supabase Backend Connected'
              : 'Supabase URL/Key needed in .env'
          }
        >
          <span
            className={`w-2 h-2 rounded-full ${
              isSupabaseConfigured ? 'bg-emerald-400 animate-pulse' : 'bg-amber-400'
            }`}
          />
          <span className="hidden md:inline">
            {isSupabaseConfigured ? 'Supabase Live' : 'Demo / Standby'}
          </span>
        </div>

        {/* User Info */}
        <div className="flex items-center gap-2 pl-2 sm:pl-3 border-l border-slate-800">
          <div className="w-8 h-8 rounded-xl bg-[#9BB7A3]/20 border border-[#9BB7A3]/30 flex items-center justify-center text-[#9BB7A3] font-bold text-xs">
            {user?.email ? user.email.charAt(0).toUpperCase() : 'A'}
          </div>
          <div className="hidden sm:block text-left">
            <p className="text-xs font-bold text-slate-200 leading-tight truncate max-w-[140px]">
              {user?.email || 'Administrator'}
            </p>
            <span className="text-[10px] text-[#9BB7A3] font-semibold uppercase tracking-wider">
              Super Admin
            </span>
          </div>
        </div>

        {/* Logout Button */}
        <button
          onClick={logout}
          title="Sign Out"
          className="p-2 rounded-xl text-slate-400 hover:text-rose-400 hover:bg-rose-950/30 border border-slate-800 hover:border-rose-900/40 transition-all duration-200"
        >
          <LogOut size={18} />
        </button>
      </div>
    </header>
  );
}
